<template>
<footer class="ftco-section" :style="{backgroundColor: informacoes[0].cor1, fontSize: '15px',padding: '3em 1em 1em'}">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-lg-4">
						<div class="ftco-footer-widget mb-5">
							<h2 class="ftco-heading-2 pb-2" :style="{color:informacoes[0].cor2}">Contatos</h2>
							<div class="block-23 mb-3">
								<ul v-if="informacoes!=''">
									<li :style="{color:informacoes[0].cor2}"><span class="icon icon-map-marker"></span><span class="text" v-html="informacoes[0].descricao1" :style="{color:informacoes[0].cor2}"></span></li>
									<li><a href="#"><span class="icon icon-phone"></span><span class="text" :style="{color:informacoes[0].cor2}">{{informacoes[0].campoExtra1}}</span></a></li>
									<li><a href="#"><span class="icon icon-envelope"></span><span class="text" :style="{color:informacoes[0].cor2}">{{informacoes[0].campoExtra2}}</span></a></li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-2">
						<div class="ftco-footer-widget mb-5">
							<h2 class="ftco-heading-2 pb-2" :style="{color:informacoes[0].cor2}">Atendimento</h2>
							<ul class="list-unstyled">
								<li class="mb-1"><a href="" @click="$redirect_reload('/')" :style="{color:informacoes[0].cor2}">
                                    <span class="ion-ios-arrow-round-forward mr-2"></span>Home</a>
								</li>
								<li class="mb-1"><a href="" @click="$redirect_reload('/sobre')" :style="{color:informacoes[0].cor2}">
                                    <span class="ion-ios-arrow-round-forward mr-2"></span>Sobre</a>
                                </li>
								<li class="mb-1"><a href="" @click="$redirect_reload('/Produtos')" :style="{color:informacoes[0].cor2}">
                                    <span	class="ion-ios-arrow-round-forward mr-2"></span>Produtos</a>
                                </li>
								<li class="mb-1"><a href="" @click="$redirect_reload('/contato')" :style="{color:informacoes[0].cor2}">
                                    <span class="ion-ios-arrow-round-forward mr-2"></span>Contato</a>
                                </li>
							</ul>
						</div>
					</div>
					<div class="col-md-6 col-lg-3">
						<div class="ftco-footer-widget mb-5 ml-md-4">
							<h2 class="ftco-heading-2 pb-2" :style="{color:informacoes[0].cor2}">Informações</h2>
							<ul class="list-unstyled">
								<li v-for="linhaRet in Retorno" :key="linhaRet.institucionalId" class="mb-1">
                                    <a href="" @click="$redirect_reload('/informacoesgerais/'+ linhaRet.institucionalId + '/' + linhaRet.nome.replaceAll(' ','-').replaceAll('/',''))" :style="{color:informacoes[0].cor2}">
                                        <span class="ion-ios-arrow-round-forward mr-2"></span>{{ linhaRet.nome }}</a>
                                </li>
							</ul>
						</div>
					</div>
					<div class="col-md-6 col-lg-3">
						<div class="ftco-footer-widget mb-5">
							<h2 class="ftco-heading-2 pb-2" :style="{color:informacoes[0].cor2}">Diproli nas Redes</h2>
						</div>
						<ul class="ftco-footer-social list-unstyled float-md-left float-lft">
							<li class=""><a v-if="Linke!='' && Linke[0].visivel" :href="Linke[0].nome" target="_blank" :style="{color:informacoes[0].cor2}"><span class="icon-linkedin"></span></a></li>
							<li class=""><a v-if="Face!='' && Face[0].visivel" :href="Face[0].nome" target="_blank" :style="{color:informacoes[0].cor2}"><span class="icon-facebook"></span></a></li>
							<li class=""><a v-if="Insta!='' && Insta[0].visivel" :href="Insta[0].nome" target="_blank" :style="{color:informacoes[0].cor2}"><span class="icon-instagram"></span></a></li>
						</ul>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 text-center">
						<div class="col text-center py-4 mt-5">
							<a href="https://avancedigital.com.br/" target="_blank"><img src="/images/avance.png" alt=""></a>
						</div>
					</div>
				</div>
			</div>
		</footer>
</template>

<script>
    export default {
        data() {
            return {
                Segmentos: [],
                informacoes: [],
                Face: [],
                Insta: [],
                Yout: [],
                Linke:[],
                logo_footer: '@/assets/img/10.png',
                logSelo: '',
                resultSelo: [],
                Retorno: [],
                linhaRet: {},
                corFundo:'',
                corLetra:'',
            }
        },
        created() {

            this.$http
                .get(this.$apiUrl + "/institucional/telas/rodapé")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.informacoes = tiu2;
                });


            this.$http
                .get(this.$apiUrl + "/institucional/telas/facebook")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.Face = tiu2
                });

            this.$http
                .get(this.$apiUrl + "/institucional/telas/instagram")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.Insta = tiu2
                });

                this.$http
                .get(this.$apiUrl + "/institucional/telas/linkedin")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.Linke = tiu2
                });

            this.$http
                .get(this.$apiUrl + "/institucional/telas/informacoesgerais")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.Retorno = tiu2.filter(x => x.visivel);
                });
        },
        mounted() {

        },
        components: {
        },
    }
</script>

<style scoped>

    .social-icon {
        background-color: #fff;
        border: 1px solid #fff;
        border-radius: 50%;
        margin-left: 8px;
        transition: transform .2s ease-in;
    }

        .social-icon:hover {
            transform: scale(1.1);
        }
</style>